import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RolloutState, RolloutUserType } from "@utils/rollout";

export enum MhtRolloutUserType {
  HOLDBACK = "HOLDBACK",
  VARIATION = "VARIATION",
  CONTROL = "CONTROL",
  FORCED_ENABLED = "FORCED_ENABLED",
  FORCED_DISABLED = "FORCED_DISABLED",
  HRT_PROMO_LP_TRAFFIC = "HRT_PROMO_LP_TRAFFIC",
}

export interface PersistentBrowserFlagsState {
  mhtRolloutUserType?: MhtRolloutUserType;
  featureRolloutTypes: Record<string, RolloutState>;
}

interface SetFeatureRolloutTypePayload {
  feature: string;
  rolloutType: RolloutUserType;
}

// Persistent flags for device-level storage
const initialState: PersistentBrowserFlagsState = {
  mhtRolloutUserType: undefined,
  featureRolloutTypes: {},
};

const persistentBrowserFlagsSlice = createSlice({
  name: "persistentBrowserFlags",
  initialState,
  reducers: {
    setMhtRolloutUserType(state, action: PayloadAction<MhtRolloutUserType>) {
      return {
        ...state,
        mhtRolloutUserType: action.payload,
      };
    },
    setFeatureRolloutType(
      state,
      action: PayloadAction<SetFeatureRolloutTypePayload>
    ) {
      const { feature, rolloutType } = action.payload;
      return {
        ...state,
        featureRolloutTypes: {
          ...state.featureRolloutTypes,
          [feature]: { rolloutType },
        },
      };
    },
  },
});

export const { setMhtRolloutUserType, setFeatureRolloutType } =
  persistentBrowserFlagsSlice.actions;

export default persistentBrowserFlagsSlice;
